import { getSelectedPerspective, setSelectedPerspective } from './selectedPerspective';

/**
 * Uitkomst van het verversen van de gebruiker na een wissel:
 * - updated: /me is gelukt en de gebruiker is bijgewerkt;
 * - ignored: het antwoord telt niet (er is intussen een nieuwere keuze, of er is
 *   geen sessie meer): niets terug te draaien;
 * - failed: /me kwam niet door; de UI toont nog het vorige perspectief.
 */
export type RefreshOutcome = 'updated' | 'ignored' | 'failed';

interface PerspectiveSwitchDeps {
  /** Reset alle queries naar de beginstand en haalt de actieve opnieuw op. */
  resetQueries: () => Promise<void>;
  /** Haalt /me opnieuw op zodat badge, kleur, icoon en favicon meelopen. */
  refreshUser: () => Promise<RefreshOutcome>;
}

// Volgnummer van de laatste wissel: een eerdere wissel mag niets meer terugdraaien
// als de gebruiker intussen opnieuw gekozen heeft.
let latestSwitch = 0;

/**
 * Maakt `perspectiveId` actief. De keuze moet opgeslagen zijn vóór de reset:
 * client.ts leest hem bij elke request en de reset haalt actieve queries
 * direct opnieuw op. Querysleutels bevatten geen perspectief, dus zonder
 * reset blijft data van het vorige perspectief staan. Komt /me niet door, dan
 * wordt de vorige keuze hersteld zodat requests en weergave niet uit elkaar
 * lopen.
 */
export async function switchToPerspective(
  perspectiveId: string,
  deps: PerspectiveSwitchDeps,
): Promise<void> {
  const ticket = ++latestSwitch;
  const previous = getSelectedPerspective();
  setSelectedPerspective(perspectiveId);

  const [, outcome] = await Promise.all([deps.resetQueries(), deps.refreshUser()]);

  if (ticket !== latestSwitch || outcome !== 'failed' || previous === null) return;
  setSelectedPerspective(previous);
  await deps.resetQueries();
}
